import axios from "axios";
import config from "./config";

const v1 = axios.create(config);

export default v1;
